
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - 사용자 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 삭제는 안되며 수정 버튼을 통해 사용 여부를 미사용으로 활용하면 됩니다.</p>
          </div>

          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_admin
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminManagementAdd?admin_ID=${this.tabulator.getSelectedData()[0].admin_ID}`
      }
    }
  },
  mounted () {
    get_admin().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'admin_ID', headerSort: false},
          {title: '사용자명', field: 'admin_name', headerSort: false},
          {title: '로그인 ID', field: 'admin_login_ID', headerSort: false},
          {title: '메뉴권한명', field: 'menu_permission_name', headerSort: false},
          {title: '활성화 여부', field: 'admin_activate', headerSort: false},
          {title: '등록 일자', field: 'admin_registe', headerSort: false},
          {title: '수정 일자', field: 'admin_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminManagement.vue